import React from 'react'

export const NotFound = function () {
    return (
        <div className="Error404">
            <h1>ERROR 404</h1>
            <h2>¯\_(ツ)_/¯</h2>
        </div>
    )
}